<div class="profile-picture box-shadow">
    <input class="file-input" type="file" #fileBrowser (change)="onFileChange($event)" multiple="false" style="display: none"/>
    <img *ngIf="url" [src]="url" (click)="fileBrowser.click()" caption="click to change"/>
    
</div>
